import React, { PureComponent, ChangeEvent } from 'react'
import { connect } from 'react-redux'
import { GetLeaveDetails } from '../Leave/LeaveAction';
import {
  FinalLeaveApprover,
  ManageLeaveApproval,
  GetAllEmployees,
  ManageEmployee,
  AllEmployeeDetailsDto,
  ManageEmployeeRequest,
  LeaveRecord
} from './EmployeeAction';

// Helper function to get employee code from session storage
const getEmployeeCodeFromSession = (): string => {
  return sessionStorage.getItem("employeeCode") || "EMP001";
};

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position:  200% center; }
  }
  @keyframes fadeSlideUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes orbPulse1 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.45; }
    50%     { transform: scale(1.1) translate(20px,-15px); opacity:.65; }
  }
  @keyframes orbPulse2 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.35; }
    50%     { transform: scale(1.07) translate(-20px,15px); opacity:.55; }
  }
  @keyframes cardIn {
    from { opacity:0; transform: translateY(20px) scale(.98); }
    to   { opacity:1; transform: translateY(0) scale(1); }
  }
  @keyframes particle {
    0%   { transform: translateY(0) translateX(0); opacity:0; }
    10%  { opacity:.8; }
    90%  { opacity:.3; }
    100% { transform: translateY(-110vh) translateX(var(--dx)); opacity:0; }
  }
  .em-particle {
    position: fixed;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(0,220,210,.8) 0%, rgba(0,160,190,.3) 60%, transparent 100%);
    animation: particle var(--dur) var(--delay) ease-in infinite;
    pointer-events: none;
    z-index: 0;
  }
  .em-page {
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    background: linear-gradient(145deg,#04111a 0%,#091e2e 35%,#0d2840 60%,#06141e 100%);
    position: relative;
    overflow-x: hidden;
    color: #e8f4f6;
    font-size: 13px;
  }
  .em-grid-bg {
    position: fixed;
    inset: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(0,210,200,.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,210,200,.025) 1px, transparent 1px);
    background-size: 55px 55px;
    z-index: 0;
  }
  .em-content {
    position: relative;
    z-index: 1;
    padding: 12px 16px 24px;
  }
  .em-breadcrumb {
    padding: 10px 20px;
    font-size: 12px;
    background: rgba(0,0,0,.25);
    border-bottom: 1px solid rgba(0,210,200,.12);
    backdrop-filter: blur(8px);
    position: sticky;
    top: 0;
    z-index: 10;
    animation: fadeSlideUp .4s ease both;
  }
  .em-breadcrumb-link { color: #00d2c8; cursor: pointer; transition: color .2s; font-size: 12px; }
  .em-breadcrumb-link:hover { color: #40e8e0; }
  .em-breadcrumb-sep { margin: 0 6px; color: rgba(0,210,200,.4); font-size: 12px; }
  .em-breadcrumb-current { color: #7ab0b8; font-weight: 600; font-size: 12px; }
  .em-section {
    border: 1px solid rgba(0,210,200,.18);
    margin-bottom: 16px;
    border-radius: 14px;
    overflow: hidden;
    background: linear-gradient(160deg, rgba(12,28,45,.96) 0%, rgba(7,18,32,.98) 100%);
    box-shadow: 0 4px 20px rgba(0,0,0,.5), 0 0 30px rgba(0,150,160,.05), inset 0 1px 0 rgba(0,210,200,.07);
    animation: cardIn .5s cubic-bezier(.16,1,.3,1) both;
    backdrop-filter: blur(12px);
  }
  .em-section:nth-child(1) { animation-delay:.05s; }
  .em-section:nth-child(2) { animation-delay:.1s; }
  .em-section:nth-child(3) { animation-delay:.15s; }
  .em-section:nth-child(4) { animation-delay:.2s; }
  .em-section:nth-child(5) { animation-delay:.25s; }
  .em-shimmer-line {
    height: 1px;
    background: linear-gradient(90deg, transparent, #00d2c8, #48cae4, #00d2c8, transparent);
    background-size: 200% auto;
    animation: shimmer 3.5s linear infinite;
  }
  .em-section-header {
    background: linear-gradient(90deg, rgba(0,160,155,.28) 0%, rgba(0,120,175,.18) 100%);
    border-bottom: 1px solid rgba(0,210,200,.15);
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;
    transition: background .2s;
  }
  .em-section-header:hover {
    background: linear-gradient(90deg, rgba(0,160,155,.38) 0%, rgba(0,120,175,.28) 100%);
  }
  .em-section-title {
    font-size: 14px;
    font-weight: 700;
    color: #e8f4f6;
    letter-spacing: .03em;
  }
  .em-toggle-btn {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: rgba(0,210,200,.15);
    border: 1px solid rgba(0,210,200,.3);
    color: #00d2c8;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all .2s;
    flex-shrink: 0;
  }
  .em-section-header:hover .em-toggle-btn {
    background: rgba(0,210,200,.25);
    box-shadow: 0 0 8px rgba(0,210,200,.3);
  }
  .em-section-body { padding: 16px 20px; }
  .em-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 12px;
  }
  .em-field { display: flex; flex-direction: column; min-width: 60px; }
  .em-label {
    font-size: 11px;
    color: #7ab0b8;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: .02em;
    font-weight: 500;
  }
  .em-input-wrap { display: flex; align-items: center; gap: 6px; }
  .em-input {
    width: 100%;
    padding: 6px 10px;
    border: 1px solid rgba(0,210,200,.18);
    border-radius: 6px;
    font-size: 12px;
    height: 32px;
    box-sizing: border-box;
    background: rgba(0,210,200,.04);
    color: #e8f4f6;
    font-family: 'DM Sans', sans-serif;
    transition: border-color .2s, box-shadow .2s, background .2s;
    outline: none;
  }
  .em-input:focus {
    border-color: #00d2c8;
    box-shadow: 0 0 0 2px rgba(0,210,200,.1);
    background: rgba(0,210,200,.07);
  }
  .em-input:hover:not(:focus) { border-color: rgba(0,210,200,.38); }
  select.em-input { cursor: pointer; font-size: 12px; }
  .em-check {
    color: #00d2c8;
    font-weight: 700;
    font-size: 14px;
    filter: drop-shadow(0 0 3px rgba(0,210,200,.7));
    flex-shrink: 0;
  }
  .em-input::placeholder { color: rgba(120,170,185,.4); font-size: 11px; }
  .em-badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
  }
  .em-badge-active {
    background: rgba(0,210,200,.15);
    border: 1px solid rgba(0,210,200,.3);
    color: #00d2c8;
  }
  .em-badge-inactive {
    background: rgba(255,80,80,.15);
    border: 1px solid rgba(255,80,80,.3);
    color: #ff5050;
  }
  .em-badge-pending {
    background: rgba(255,170,0,.15);
    border: 1px solid rgba(255,170,0,.3);
    color: #ffaa00;
  }
  .em-badge-approved {
    background: rgba(0,210,200,.15);
    border: 1px solid rgba(0,210,200,.3);
    color: #00d2c8;
  }
  .em-stats-grid {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  .em-stat-card {
    background: rgba(0,210,200,.05);
    border: 1px solid rgba(0,210,200,.15);
    border-radius: 10px;
    padding: 16px 20px;
    min-width: 150px;
    flex: 1;
  }
  .em-stat-value {
    font-size: 26px;
    font-weight: 700;
    color: #00d2c8;
    line-height: 1.2;
  }
  .em-stat-label {
    font-size: 11px;
    color: #7ab0b8;
    text-transform: uppercase;
    letter-spacing: .03em;
    margin-top: 4px;
  }
  .em-action-btn {
    padding: 6px 14px;
    background: rgba(0,210,200,.15);
    border: 1px solid rgba(0,210,200,.3);
    border-radius: 20px;
    color: #00d2c8;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all .2s;
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }
  .em-action-btn:hover {
    background: rgba(0,210,200,.25);
    box-shadow: 0 0 8px rgba(0,210,200,.3);
  }
  .em-action-btn-danger {
    background: rgba(255,80,80,.15);
    border: 1px solid rgba(255,80,80,.3);
    color: #ff5050;
  }
  .em-action-btn-danger:hover {
    background: rgba(255,80,80,.25);
  }
  .em-action-btn-success {
    background: rgba(0,210,200,.15);
    border: 1px solid rgba(0,210,200,.3);
    color: #00d2c8;
  }
  .em-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
  }
  .em-table th {
    text-align: left;
    padding: 10px 10px;
    color: #7ab0b8;
    font-weight: 600;
    border-bottom: 1px solid rgba(0,210,200,.15);
    font-size: 12px;
  }
  .em-table td {
    padding: 8px 10px;
    border-bottom: 1px solid rgba(0,210,200,.08);
    font-size: 11px;
  }
  .em-empty-state {
    text-align: center;
    padding: 36px 20px;
    color: #7ab0b8;
    font-size: 12px;
    background: rgba(0,210,200,.02);
    border-radius: 6px;
  }
  .em-filter-bar {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    flex-wrap: wrap;
    align-items: flex-end;
  }
  .em-tabs {
    display: flex;
    gap: 4px;
    margin-bottom: 16px;
    border-bottom: 1px solid rgba(0,210,200,.15);
  }
  .em-tab {
    padding: 8px 16px;
    font-size: 12px;
    font-weight: 600;
    color: #7ab0b8;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all .2s;
  }
  .em-tab-active {
    color: #00d2c8;
    border-bottom: 2px solid #00d2c8;
  }
  .em-input[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .em-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    animation: fadeSlideUp 0.3s ease;
  }
  .em-modal-content {
    background: linear-gradient(160deg, rgba(12,28,45,.98) 0%, rgba(7,18,32,.98) 100%);
    border: 1px solid rgba(0,210,200,.3);
    border-radius: 14px;
    padding: 24px;
    width: 720px;
    max-width: 85vw;
    max-height: 85vh;
    overflow-y: auto;
  }
  .em-modal-title {
    color: #00d2c8;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0,210,200,.2);
  }
  .em-password-strength {
    font-size: 10px;
    margin-top: 4px;
    color: #7ab0b8;
  }
  .em-password-weak { color: #ff5050; }
  .em-password-medium { color: #ffaa00; }
  .em-password-strong { color: #00d2c8; }
  .em-success-message {
    background: rgba(0,210,200,.1);
    border: 1px solid #00d2c8;
    color: #00d2c8;
    padding: 10px 14px;
    border-radius: 6px;
    margin-bottom: 12px;
    font-size: 12px;
  }
  .em-error-message {
    background: rgba(255,80,80,.1);
    border: 1px solid #ff5050;
    color: #ff5050;
    padding: 10px 14px;
    border-radius: 6px;
    margin-bottom: 12px;
    font-size: 12px;
  }
  .em-photo-preview {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #00d2c8;
  }
  .em-photo-placeholder {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(0,210,200,.1);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #00d2c8;
    color: #00d2c8;
    font-size: 28px;
  }
  .em-photo-upload-container {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    padding: 12px;
    background: rgba(0,210,200,.05);
    border-radius: 10px;
  }
  .em-code-hint {
    font-size: 10px;
    color: #00d2c8;
    margin-top: 2px;
  }
  .em-photo-upload-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: rgba(0,210,200,.1);
    border: 1px dashed rgba(0,210,200,.3);
    border-radius: 6px;
    color: #00d2c8;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .em-photo-upload-btn:hover {
    background: rgba(0,210,200,.2);
    border-color: #00d2c8;
  }
  .em-photo-remove-btn {
    padding: 4px 8px;
    background: rgba(255,80,80,.1);
    border: 1px solid rgba(255,80,80,.3);
    border-radius: 5px;
    color: #ff5050;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .em-photo-remove-btn:hover {
    background: rgba(255,80,80,.2);
  }
`

const PARTICLES = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  size: Math.random() * 4 + 2,
  left: Math.random() * 100,
  dur: Math.random() * 12 + 8,
  delay: Math.random() * 10,
  dx: (Math.random() - 0.5) * 100,
}))

// Department options
const departments = ['Engineering', 'HR', 'Finance', 'Marketing', 'Sales & Operations', 'Senior-level Manager','Front office','Office Administration']
const designations = ['Software Developer', 'Senior Developer', 'HR Manager', 'Accountant', 'Marketing Lead', 'Operations Manager', 'Sales Executive', 'Senior Manager', 
  'Admin & Operations', 'Director', 'Front Office Executive ','Office Administrator']
const statusOptions = ['Active', 'Inactive']
const leaveTypes = ['All', 'Annual Leave', 'Sick Leave', 'Casual Leave', 'Maternity Leave', 'Paternity Leave']
const employmentStatusOptions = ['Full Time', 'Part Time', 'Contract', 'Intern']
const leaveStatusOptions = ['All', 'Pending', 'Approved', 'Rejected', 'Final Approved', 'Final Rejected']

// Default placeholder for images when loading fails
const DEFAULT_AVATAR = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><circle cx="25" cy="25" r="25" fill="%2300d2c8" opacity="0.2"/><text x="25" y="32" font-size="20" text-anchor="middle" fill="%2300d2c8" font-family="Arial">👤</text></svg>';

interface ColSectionState { open: boolean }
interface ColSectionProps { title: string; defaultOpen?: boolean; children?: React.ReactNode }

class CollapsibleSection extends React.Component<ColSectionProps, ColSectionState> {
  constructor(props: ColSectionProps) {
    super(props)
    this.state = { open: props.defaultOpen ?? false }
  }
  toggle = () => this.setState(s => ({ open: !s.open }))
  render() {
    const { title, children } = this.props
    const { open } = this.state

    return (
      <div className="em-section">
        <div className="em-shimmer-line" />
        <div className="em-section-header" onClick={this.toggle}>
          <span className="em-section-title">{title}</span>
          <span className="em-toggle-btn">{open ? '−' : '+'}</span>
        </div>
        {open && <div className="em-section-body">{children}</div>}
      </div>
    )
  }
}

interface FieldProps {
  label: string
  value?: string
  width?: string
  type?: string
  verified?: boolean
  isSelect?: boolean
  options?: string[]
  disabled?: boolean
  placeholder?: string
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  showPasswordStrength?: boolean
}

function Field({
  label,
  value = '',
  width = 'auto',
  type = 'text',
  verified,
  isSelect,
  options = [],
  disabled,
  placeholder,
  onChange,
  showPasswordStrength
}: FieldProps) {

  const getPasswordStrength = (password: string): { text: string; className: string } => {
    if (!password) return { text: '', className: '' }
    if (password.length < 6) return { text: 'Weak', className: 'em-password-weak' }
    if (password.length < 10) return { text: 'Medium', className: 'em-password-medium' }
    return { text: 'Strong', className: 'em-password-strong' }
  }

  const strength = type === 'password' && showPasswordStrength ? getPasswordStrength(value) : null

  return (
    <div className="em-field" style={{ width }}>
      <label className="em-label">{label}</label>
      <div className="em-input-wrap">
        {isSelect ? (
          <select className="em-input" value={value} onChange={onChange} disabled={disabled}>
            {options.map(o => (
              <option key={o} style={{ background: '#091e2e', color: '#e8f4f6', fontSize: '12px' }}>{o}</option>
            ))}
          </select>
        ) : (
          <input
            className="em-input"
            type={type}
            value={value}
            onChange={onChange}
            disabled={disabled}
            placeholder={placeholder}
          />
        )}
        {verified && <span className="em-check">✓</span>}
      </div>
      {strength && strength.text && (
        <div className={`em-password-strength ${strength.className}`}>
          Password Strength: {strength.text}
        </div>
      )}
    </div>
  )
}

function Row({ children }: { children: React.ReactNode }) {
  return <div className="em-row">{children}</div>
}

function Badge({ status }: { status: string | boolean }) {
  const statusStr = typeof status === 'boolean' ? (status ? 'Active' : 'Inactive') : status;

  const getClassName = () => {
    switch (statusStr.toLowerCase()) {
      case 'active': return 'em-badge-active'
      case 'inactive': return 'em-badge-inactive'
      case 'pending': return 'em-badge-pending'
      case 'approved': return 'em-badge-approved'
      case 'final approved': return 'em-badge-approved'
      case 'rejected': return 'em-badge-inactive'
      case 'final rejected': return 'em-badge-inactive'
      default: return 'em-badge-active'
    }
  }

  return (
    <span className={`em-badge ${getClassName()}`}>
      {statusStr}
    </span>
  )
}

// Extended interface to handle the empty key from API
interface ExtendedEmployeeDto extends AllEmployeeDetailsDto {
  " "?: string; // Empty string key that contains the photo URL
}

interface EmployeeManagementPageProps {
  leaveRecords?: LeaveRecord[];
  employeeRecords?: AllEmployeeDetailsDto[];
  loading?: boolean;
  manageStatus?: any;
  error?: any;
  GetLeaveDetails: (employeeCode?: string) => Promise<any>;
  GetAllEmployees: () => Promise<any>;
  ManageLeaveApproval: (approvalData: any) => Promise<any>;
  FinalLeaveApprover: (approvalData: any) => Promise<any>;
  ManageEmployee: (employeeData: ManageEmployeeRequest) => Promise<any>;
}

interface EmployeeManagementPageState {
  allLeaveRequests: LeaveRecord[]; // Store all leave requests
  filteredLeaveRequests: LeaveRecord[];
  loading: boolean;
  processingId: string | null;
  employees: ExtendedEmployeeDto[];
  filteredEmployees: ExtendedEmployeeDto[];
  employeeLoading: boolean;
  newEmployeeForm: Partial<ManageEmployeeRequest>;
  editingEmployee: (ExtendedEmployeeDto & { password?: string }) | null;
  showEditModal: boolean;
  searchTerm: string;
  departmentFilter: string;
  statusFilter: string;
  leaveTypeFilter: string;
  leaveStatusFilter: string; // Add filter for leave status
  fromDateFilter: string;
  toDateFilter: string;
  showPassword: boolean;
  showEditPassword: boolean;
  showSuccessMessage: string | null;
  showErrorMessage: string | null;
  editPassword: string;
  imageError: { [key: string]: boolean };
  selectedPhotoFile: File | null;
  selectedEditPhotoFile: File | null;
  photoPreview: string | null;
  editPhotoPreview: string | null;
  isUploading: boolean;
  isEditUploading: boolean;
  uploadProgress: number;
}

class EmployeeManagementPage extends PureComponent<EmployeeManagementPageProps, EmployeeManagementPageState> {
  private fileInputRef = React.createRef<HTMLInputElement>();
  private editFileInputRef = React.createRef<HTMLInputElement>();

  constructor(props: EmployeeManagementPageProps) {
    super(props);
    this.state = {
      allLeaveRequests: [], // Store all leave requests
      filteredLeaveRequests: [],
      loading: false,
      processingId: null,
      employees: this.mapEmployeeRecords(props.employeeRecords || []),
      filteredEmployees: this.mapEmployeeRecords(props.employeeRecords || []),
      employeeLoading: false,
      newEmployeeForm: {
        indicator: "I",
        employeeCode: "",
        firstName: "",
        lastName: "",
        employeeName: "",
        email: "",
        mobileNumber: "",
        password: "",
        dateOfBirth: "",
        employeeAddress: "",
        addressLine2: "",
        city: "",
        state: "West Bengal",
        pincode: "",
        department: "Engineering",
        designation: "Software Developer",
        joinDate: new Date().toISOString().split('T')[0],
        employmentStatus: "Full Time",
        isActive: true,
        emergencyContactName: "",
        emergencyContactNumber: "",
        relationship: "",
        roleId: 2,
        updatedBy: getEmployeeCodeFromSession(),
        photoPath: ""
      },
      editingEmployee: null,
      showEditModal: false,
      searchTerm: "",
      departmentFilter: "All",
      statusFilter: "All",
      leaveTypeFilter: "All",
      leaveStatusFilter: "All", // Initialize leave status filter
      fromDateFilter: "",
      toDateFilter: "",
      showPassword: false,
      showEditPassword: false,
      showSuccessMessage: null,
      showErrorMessage: null,
      editPassword: "",
      imageError: {},
      selectedPhotoFile: null,
      selectedEditPhotoFile: null,
      photoPreview: null,
      editPhotoPreview: null,
      isUploading: false,
      isEditUploading: false,
      uploadProgress: 0
    };
  }

  // Helper function to map employee records and handle the empty key photo URL
  mapEmployeeRecords = (records: AllEmployeeDetailsDto[]): ExtendedEmployeeDto[] => {
    if (!records || records.length === 0) return [];

    return records.map((record: any) => {
      // Check if there's a field with empty string key (contains the photo URL)
      const photoUrl = record[" "] || record.photoPath || "";

      // Log for debugging
      if (photoUrl) {
        console.log(`Mapped photo URL for ${record.employeeName || record.firstName}:`, photoUrl);
      }

      return {
        ...record,
        " ": photoUrl // Keep the original empty key as well
      };
    });
  };

  // Get photo URL from employee object (handles both photoPath and empty key)
  getEmployeePhotoUrl = (employee: ExtendedEmployeeDto): string => {
    // Check photoPath first (if it exists from the original record), then fall back to the empty key
    const photoUrl = (employee as any).photoPath || employee[" "] || "";
    return photoUrl;
  };

  componentDidMount() {
    this.fetchAllData();
  }

  componentDidUpdate(prevProps: EmployeeManagementPageProps, prevState: EmployeeManagementPageState) {
    if (prevProps.employeeRecords !== this.props.employeeRecords) {
      console.log("Employee records received from API:", this.props.employeeRecords);
      if (this.props.employeeRecords && this.props.employeeRecords.length > 0) {
        const mappedRecords = this.mapEmployeeRecords(this.props.employeeRecords);
        this.setState({
          employees: mappedRecords,
          filteredEmployees: mappedRecords
        });
      }
    }

    if (
      prevState.searchTerm !== this.state.searchTerm ||
      prevState.departmentFilter !== this.state.departmentFilter ||
      prevState.statusFilter !== this.state.statusFilter ||
      prevState.employees !== this.state.employees
    ) {
      this.applyFilters();
    }

    // Apply leave filters when any leave filter changes
    if (
      prevState.leaveTypeFilter !== this.state.leaveTypeFilter ||
      prevState.leaveStatusFilter !== this.state.leaveStatusFilter ||
      prevState.fromDateFilter !== this.state.fromDateFilter ||
      prevState.toDateFilter !== this.state.toDateFilter ||
      prevState.allLeaveRequests !== this.state.allLeaveRequests
    ) {
      this.applyLeaveFilters();
    }

    if (prevProps.leaveRecords !== this.props.leaveRecords && this.props.leaveRecords) {
      this.storeAllLeaveRequests(this.props.leaveRecords);
    }

    if (prevProps.manageStatus !== this.props.manageStatus) {
      if (this.props.manageStatus?.success) {
        this.showTemporarySuccess(this.props.manageStatus.message || 'Operation successful');
      } else if (this.props.manageStatus?.error) {
        this.showTemporaryError(this.props.manageStatus.message || 'Operation failed');
      }
    }
  }

  // Handle image error
  handleImageError = (employeeId: number) => {
    this.setState(prev => ({
      imageError: {
        ...prev.imageError,
        [employeeId]: true
      }
    }));
  };

  // Apply filters to employees list
  applyFilters = () => {
    const { employees, searchTerm, departmentFilter, statusFilter } = this.state;

    let filtered = [...employees];

    if (departmentFilter !== "All") {
      filtered = filtered.filter(emp => emp.department === departmentFilter);
    }

    if (statusFilter !== "All") {
      const isActive = statusFilter === "Active";
      filtered = filtered.filter(emp => emp.isActive === isActive);
    }

    if (searchTerm.trim() !== "") {
      const term = searchTerm.toLowerCase().trim();
      filtered = filtered.filter(emp =>
        (emp.firstName?.toLowerCase() || '').includes(term) ||
        (emp.lastName?.toLowerCase() || '').includes(term) ||
        (emp.employeeName?.toLowerCase() || '').includes(term) ||
        (emp.displayName?.toLowerCase() || '').includes(term) ||
        (emp.employeeCode?.toLowerCase() || '').includes(term) ||
        (emp.email?.toLowerCase() || '').includes(term) ||
        (emp.mobileNumber || '').includes(term) ||
        (emp.department?.toLowerCase() || '').includes(term) ||
        (emp.designation?.toLowerCase() || '').includes(term)
      );
    }

    this.setState({ filteredEmployees: filtered });
  };

  // Apply filters to leave requests
  applyLeaveFilters = () => {
    const { allLeaveRequests, leaveTypeFilter, leaveStatusFilter, fromDateFilter, toDateFilter } = this.state;

    let filtered = [...allLeaveRequests];

    // Filter by leave type
    if (leaveTypeFilter !== "All") {
      filtered = filtered.filter(request => request.leaveType === leaveTypeFilter);
    }

    // Filter by leave status
    if (leaveStatusFilter !== "All") {
      filtered = filtered.filter(request =>
        request.status?.toLowerCase() === leaveStatusFilter.toLowerCase()
      );
    }

    // Filter by from date
    if (fromDateFilter) {
      const fromDate = new Date(fromDateFilter);
      filtered = filtered.filter(request => new Date(request.fromDate) >= fromDate);
    }

    // Filter by to date
    if (toDateFilter) {
      const toDate = new Date(toDateFilter);
      filtered = filtered.filter(request => new Date(request.fromDate) <= toDate);
    }

    this.setState({ filteredLeaveRequests: filtered });
  };

  // Format employee code to EMP001 format
  formatEmployeeCode = (input: string): string => {
    let cleaned = input.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    if (cleaned.startsWith('EMP')) {
      const numberPart = cleaned.substring(3);
      if (numberPart) {
        const num = parseInt(numberPart, 10);
        if (!isNaN(num)) {
          return `EMP${num.toString().padStart(3, '0')}`;
        }
      }
      return cleaned;
    }

    if (/^\d+$/.test(cleaned)) {
      const num = parseInt(cleaned, 10);
      return `EMP${num.toString().padStart(3, '0')}`;
    }

    return cleaned;
  };

  showTemporarySuccess = (message: string) => {
    this.setState({ showSuccessMessage: message });
    setTimeout(() => {
      this.setState({ showSuccessMessage: null });
    }, 3000);
  };

  showTemporaryError = (message: string) => {
    this.setState({ showErrorMessage: message });
    setTimeout(() => {
      this.setState({ showErrorMessage: null });
    }, 3000);
  };

  fetchAllData = async () => {
    this.setState({ employeeLoading: true, loading: true });
    try {
      const result = await this.props.GetAllEmployees();
      console.log("GetAllEmployees result:", result);

      if (result?.records && result.records.length > 0) {
        const mappedRecords = this.mapEmployeeRecords(result.records);
        this.setState({
          employees: mappedRecords,
          filteredEmployees: mappedRecords
        });
      }

      await this.fetchAllLeaveRequests();
    } catch (error) {
      console.error("Error fetching data:", error);
      this.showTemporaryError("Failed to fetch data");
    } finally {
      this.setState({ employeeLoading: false, loading: false });
    }
  };

  fetchAllLeaveRequests = async () => {
    this.setState({ loading: true });
    try {
      const employeeCode = sessionStorage.getItem("employeeCode") || undefined;
      const result = await this.props.GetLeaveDetails(employeeCode);
      console.log("All leave details result:", result);
      if (result?.records) {
        this.storeAllLeaveRequests(result.records);
      }
    } catch (error) {
      console.error("Error fetching leave requests:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  // Store all leave requests without filtering by status
  storeAllLeaveRequests = (records: LeaveRecord[]) => {
    // Store all records regardless of status
    const allRequests = records;
    console.log("All leave requests (all statuses):", allRequests);

    this.setState({
      allLeaveRequests: allRequests,
      filteredLeaveRequests: allRequests
    });
  };

  // Upload image to server and return S3 URL
  uploadImageToServer = async (file: File): Promise<string> => {
    const formData = new FormData();
    formData.append('file', file);

    // Get the API base URL from environment or use default
    const baseUrl = process.env.REACT_APP_API_URL || '';
    const uploadUrl = `${baseUrl}/api/employee/upload-photo`;

    console.log("Uploading to:", uploadUrl);
    console.log("File type:", file.type);
    console.log("File size:", file.size);

    try {
      const response = await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Upload failed with status:", response.status, errorText);
        throw new Error(`Upload failed: ${response.status} ${errorText}`);
      }

      const data = await response.json();
      console.log("Upload response:", data);

      // Handle different response formats - Expecting S3 URL like: https://company-assets.s3.amazonaws.com/employee-photos/e234_rahul_verma.jpg
      const imageUrl = data.url || data.imageUrl || data.data?.url || data.secure_url || data.path || data.fileUrl;

      if (!imageUrl) {
        console.error('Unexpected response format:', data);
        throw new Error('Could not get image URL from server response');
      }

      console.log("Uploaded image URL:", imageUrl);
      return imageUrl;

    } catch (error) {
      console.error('Upload error:', error);
      throw error;
    }
  };

  // Handle Photo Upload for New Employee - Only server upload, no base64 fallback
  handlePhotoUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      this.showTemporaryError('Please upload only image files (JPEG, PNG, GIF, WEBP)');
      return;
    }

    // Validate file size (5MB max)
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      this.showTemporaryError('File size must be less than 5MB');
      return;
    }

    // Show local preview
    const reader = new FileReader();
    reader.onload = (e) => {
      this.setState({ photoPreview: e.target?.result as string });
    };
    reader.readAsDataURL(file);

    this.setState({ isUploading: true, uploadProgress: 0 });

    try {
      // Upload to server - must return S3 URL
      const imageUrl = await this.uploadImageToServer(file);

      // Store the URL in photoPath (S3 URL format)
      this.setState(prev => ({
        newEmployeeForm: {
          ...prev.newEmployeeForm,
          photoPath: imageUrl
        },
        isUploading: false,
        uploadProgress: 100
      }));

      console.log("Photo uploaded successfully, S3 URL saved:", imageUrl);
      this.showTemporarySuccess('Photo uploaded successfully!');

    } catch (error) {
      console.error('Upload error:', error);
      this.showTemporaryError('Error uploading photo. Please try again.');
      this.setState({
        photoPreview: null,
        isUploading: false
      });
    }
  };

  // Handle Photo Upload for Edit Modal - Only server upload, no base64 fallback
  handleEditPhotoUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      this.showTemporaryError('Please upload only image files (JPEG, PNG, GIF, WEBP)');
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      this.showTemporaryError('File size must be less than 5MB');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      this.setState({ editPhotoPreview: e.target?.result as string });
    };
    reader.readAsDataURL(file);

    this.setState({ isEditUploading: true });

    try {
      // Upload to server - must return S3 URL
      const imageUrl = await this.uploadImageToServer(file);

      // Store the URL in photoPath (S3 URL format)
      this.setState(prev => ({
        editingEmployee: prev.editingEmployee ? {
          ...prev.editingEmployee,
          photoPath: imageUrl
        } : null,
        isEditUploading: false
      }));

      console.log("Edit photo uploaded successfully, S3 URL saved:", imageUrl);
      this.showTemporarySuccess('Photo uploaded successfully!');

    } catch (error) {
      console.error('Upload error:', error);
      this.showTemporaryError('Error uploading photo. Please try again.');
      this.setState({
        editPhotoPreview: null,
        isEditUploading: false
      });
    }
  };

  triggerFileInput = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  triggerEditFileInput = () => {
    if (this.editFileInputRef.current) {
      this.editFileInputRef.current.click();
    }
  };

  removeNewEmployeePhoto = () => {
    this.setState(prev => ({
      newEmployeeForm: {
        ...prev.newEmployeeForm,
        photoPath: ""
      },
      selectedPhotoFile: null,
      photoPreview: null
    }));
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };

  removeEditEmployeePhoto = () => {
    this.setState(prev => ({
      editingEmployee: prev.editingEmployee ? {
        ...prev.editingEmployee,
        photoPath: ""
      } : null,
      selectedEditPhotoFile: null,
      editPhotoPreview: null
    }));
    if (this.editFileInputRef.current) {
      this.editFileInputRef.current.value = '';
    }
  };

  handleCreateEmployee = async () => {
    const { newEmployeeForm } = this.state;

    if (!newEmployeeForm.employeeCode) {
      this.showTemporaryError("Employee Code is required (Format: EMP001)");
      return;
    }

    const formattedCode = this.formatEmployeeCode(newEmployeeForm.employeeCode);

    if (!formattedCode.startsWith('EMP') || formattedCode.length !== 6) {
      this.showTemporaryError("Employee Code must be in format EMP001 (EMP followed by 3 digits)");
      return;
    }

    if (!newEmployeeForm.firstName || !newEmployeeForm.email || !newEmployeeForm.mobileNumber) {
      this.showTemporaryError("Please fill in all required fields (First Name, Email, Phone)");
      return;
    }

    if (!newEmployeeForm.password) {
      this.showTemporaryError("Password is required for new employees");
      return;
    }

    const employeeData: ManageEmployeeRequest = {
      indicator: "I",
      employeeCode: formattedCode,
      firstName: newEmployeeForm.firstName || '',
      lastName: newEmployeeForm.lastName || '',
      employeeName: `${newEmployeeForm.firstName || ''} ${newEmployeeForm.lastName || ''}`.trim(),
      email: newEmployeeForm.email || '',
      mobileNumber: newEmployeeForm.mobileNumber || '',
      password: newEmployeeForm.password || '',
      dateOfBirth: newEmployeeForm.dateOfBirth || '',
      employeeAddress: newEmployeeForm.employeeAddress || '',
      addressLine2: newEmployeeForm.addressLine2 || '',
      city: newEmployeeForm.city || '',
      state: newEmployeeForm.state || 'West Bengal',
      pincode: newEmployeeForm.pincode || '',
      department: newEmployeeForm.department || 'Engineering',
      designation: newEmployeeForm.designation || 'Software Developer',
      joinDate: newEmployeeForm.joinDate || new Date().toISOString().split('T')[0],
      employmentStatus: newEmployeeForm.employmentStatus || 'Full Time',
      isActive: newEmployeeForm.isActive !== undefined ? newEmployeeForm.isActive : true,
      emergencyContactName: newEmployeeForm.emergencyContactName || '',
      emergencyContactNumber: newEmployeeForm.emergencyContactNumber || '',
      relationship: newEmployeeForm.relationship || '',
      roleId: newEmployeeForm.roleId || 2,
      updatedBy: getEmployeeCodeFromSession()
    };

    if (newEmployeeForm.photoPath) {
      employeeData.photoPath = newEmployeeForm.photoPath;
      console.log("Adding S3 photo URL to employee data:", employeeData.photoPath);
    }

    console.log("Creating employee with data:", employeeData);

    this.setState({ employeeLoading: true });

    try {
      const result = await this.props.ManageEmployee(employeeData);
      console.log("Create employee result:", result);

      if (result?.success || result?.isSuccess) {
        this.showTemporarySuccess("Employee created successfully!");
        this.resetNewEmployeeForm();

        setTimeout(() => {
          this.props.GetAllEmployees();
        }, 500);

      } else {
        this.showTemporaryError(result?.message || "Failed to create employee");
      }
    } catch (error) {
      console.error("Create employee error:", error);
      this.showTemporaryError("Error creating employee: ");
    } finally {
      this.setState({ employeeLoading: false });
    }
  };

  handleUpdateEmployee = async () => {
    const { editingEmployee, editPassword } = this.state;

    if (!editingEmployee) return;

    const employeeData: ManageEmployeeRequest = {
      indicator: "U",
      employeeId: editingEmployee.employeeId,
      employeeCode: editingEmployee.employeeCode,
      firstName: editingEmployee.firstName || '',
      lastName: editingEmployee.lastName || '',
      employeeName: editingEmployee.employeeName || `${editingEmployee.firstName || ''} ${editingEmployee.lastName || ''}`.trim(),
      email: editingEmployee.email || '',
      mobileNumber: editingEmployee.mobileNumber || '',
      dateOfBirth: editingEmployee.dateOfBirth || '',
      employeeAddress: editingEmployee.employeeAddress || '',
      addressLine2: editingEmployee.addressLine2 || '',
      city: editingEmployee.city || '',
      state: editingEmployee.state || '',
      pincode: editingEmployee.pincode || '',
      department: editingEmployee.department || '',
      designation: editingEmployee.designation || '',
      joinDate: editingEmployee.joinDate || '',
      employmentStatus: editingEmployee.employmentStatus || 'Full Time',
      isActive: editingEmployee.isActive !== undefined ? editingEmployee.isActive : true,
      emergencyContactName: editingEmployee.emergencyContactName || '',
      emergencyContactNumber: editingEmployee.emergencyContactNumber || '',
      relationship: editingEmployee.relationship || '',
      roleId: editingEmployee.roleId || 2,
      updatedBy: getEmployeeCodeFromSession()
    };

    if ((editingEmployee as any).photoPath) {
      employeeData.photoPath = (editingEmployee as any).photoPath;
      console.log("Adding S3 photo URL to update:", employeeData.photoPath);
    }

    if (editPassword) {
      employeeData.password = editPassword;
    }

    console.log("Updating employee with data:", employeeData);

    this.setState({ employeeLoading: true });

    try {
      const result = await this.props.ManageEmployee(employeeData);
      console.log("Update employee result:", result);

      if (result?.success || result?.isSuccess) {
        this.showTemporarySuccess("Employee updated successfully!");
        this.setState({
          showEditModal: false,
          editingEmployee: null,
          editPassword: "",
          editPhotoPreview: null
        });

        setTimeout(() => {
          this.props.GetAllEmployees();
        }, 500);

      } else {
        this.showTemporaryError(result?.message || "Failed to update employee");
      }
    } catch (error) {
      console.error("Update employee error:", error);
      this.showTemporaryError("Error updating employee: ");
    } finally {
      this.setState({ employeeLoading: false });
    }
  };

  handleDeleteEmployee = async (employeeId: number, employeeCode: string, employeeName: string) => {
    if (!window.confirm(`Are you sure you want to delete employee ${employeeName}?`)) {
      return;
    }

    const deleteData: ManageEmployeeRequest = {
      indicator: "D",
      employeeId: employeeId,
      employeeCode: employeeCode,
      updatedBy: getEmployeeCodeFromSession()
    };

    this.setState({ employeeLoading: true, processingId: `delete-${employeeId}` });

    try {
      const result = await this.props.ManageEmployee(deleteData);
      console.log("Delete employee result:", result);

      if (result?.success) {
        this.showTemporarySuccess("Employee deleted successfully!");
        await this.props.GetAllEmployees();
      } else {
        this.showTemporaryError(result?.message || "Failed to delete employee");
      }
    } catch (error) {
      console.error("Delete employee error:", error);
      this.showTemporaryError("Error deleting employee");
    } finally {
      this.setState({ employeeLoading: false, processingId: null });
    }
  };

  handleEditClick = (employee: ExtendedEmployeeDto) => {
    this.setState({
      editingEmployee: { ...employee },
      showEditModal: true,
      editPassword: "",
      showEditPassword: false,
      selectedEditPhotoFile: null,
      editPhotoPreview: this.getEmployeePhotoUrl(employee)
    });
  };

  handleNewEmployeeInputChange = (field: keyof ManageEmployeeRequest, value: string | boolean | number) => {
    if (field === 'employeeCode' && typeof value === 'string') {
      const formatted = this.formatEmployeeCode(value);
      this.setState(prev => ({
        newEmployeeForm: {
          ...prev.newEmployeeForm,
          [field]: formatted
        }
      }));
    } else {
      this.setState(prev => ({
        newEmployeeForm: {
          ...prev.newEmployeeForm,
          [field]: value
        }
      }));
    }
  };

  handleEditInputChange = (field: keyof ExtendedEmployeeDto, value: string | boolean | number) => {
    if (!this.state.editingEmployee) return;

    let processedValue = value;
    const numberFields = ['employeeId', 'age', 'rowNum', 'totalCount', 'roleId', 'experienceYears'];
    if (numberFields.includes(field) && typeof value === 'string') {
      processedValue = parseInt(value, 10) || 0;
    }

    if (field === 'employeeCode' && typeof value === 'string') {
      processedValue = this.formatEmployeeCode(value);
    }

    this.setState(prev => ({
      editingEmployee: {
        ...prev.editingEmployee!,
        [field]: processedValue
      }
    }));
  };

  togglePasswordVisibility = () => {
    this.setState(prev => ({ showPassword: !prev.showPassword }));
  };

  toggleEditPasswordVisibility = () => {
    this.setState(prev => ({ showEditPassword: !prev.showEditPassword }));
  };

  resetNewEmployeeForm = () => {
    this.setState({
      newEmployeeForm: {
        indicator: "I",
        employeeCode: "",
        firstName: "",
        lastName: "",
        employeeName: "",
        email: "",
        mobileNumber: "",
        password: "",
        dateOfBirth: "",
        employeeAddress: "",
        addressLine2: "",
        city: "",
        state: "West Bengal",
        pincode: "",
        department: "Engineering",
        designation: "Software Developer",
        joinDate: new Date().toISOString().split('T')[0],
        employmentStatus: "Full Time",
        isActive: true,
        emergencyContactName: "",
        emergencyContactNumber: "",
        relationship: "",
        roleId: 2,
        updatedBy: getEmployeeCodeFromSession(),
        photoPath: ""
      },
      selectedPhotoFile: null,
      photoPreview: null
    });
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };

  clearFilters = () => {
    this.setState({
      searchTerm: "",
      departmentFilter: "All",
      statusFilter: "All"
    });
  };

  clearLeaveFilters = () => {
    this.setState({
      leaveTypeFilter: "All",
      leaveStatusFilter: "All",
      fromDateFilter: "",
      toDateFilter: ""
    }, () => {
      this.applyLeaveFilters();
    });
  };

  handleApprove = async (request: LeaveRecord) => {
    const confirmApprove = window.confirm(`Approve leave request for ${request.employeeName}?`);
    if (!confirmApprove) return;

    const requestId = request.leaveRequestId;
    if (!requestId) {
      this.showTemporaryError("Invalid request ID");
      return;
    }

    this.setState({ processingId: requestId });

    try {
      const approvalData = {
        employeeCode: request.employeeCode,
        hrEmployeeCode: getEmployeeCodeFromSession(),
        leaveRequestId: requestId,
        rejectionReason: "",
        status: "APPROVE"
      };

      const result = await this.props.ManageLeaveApproval(approvalData);
      console.log("Approve result:", result);

      if (result?.isSuccess) {
        this.showTemporarySuccess(`Leave request approved successfully!`);
        this.fetchAllLeaveRequests(); // Refresh all leave requests
      } else {
        this.showTemporaryError(result?.message || "Failed to approve leave request");
      }
    } catch (error) {
      console.error("Approve error:", error);
      this.showTemporaryError("Error approving leave request");
    } finally {
      this.setState({ processingId: null });
    }
  };

  handleReject = async (request: LeaveRecord) => {
    const rejectionReason = window.prompt("Please enter reason for rejection:", "");
    if (rejectionReason === null) return;
    if (!rejectionReason.trim()) {
      this.showTemporaryError("Rejection reason is required");
      return;
    }

    const requestId = request.leaveRequestId;
    if (!requestId) {
      this.showTemporaryError("Invalid request ID");
      return;
    }

    this.setState({ processingId: requestId });

    try {
      const approvalData = {
        employeeCode: request.employeeCode,
        hrEmployeeCode: getEmployeeCodeFromSession(),
        leaveRequestId: requestId,
        rejectionReason: rejectionReason,
        status: "REJECTED"
      };

      const result = await this.props.ManageLeaveApproval(approvalData);
      console.log("Reject result:", result);

      if (result?.isSuccess) {
        this.showTemporarySuccess(`Leave request rejected successfully!`);
        this.fetchAllLeaveRequests(); // Refresh all leave requests
      } else {
        this.showTemporaryError(result?.message || "Failed to reject leave request");
      }
    } catch (error) {
      console.error("Reject error:", error);
      this.showTemporaryError("Error rejecting leave request");
    } finally {
      this.setState({ processingId: null });
    }
  };

  handleFinalApprove = async (request: LeaveRecord) => {
    const confirmApprove = window.confirm(
      `Final approval for ${request.employeeName}'s leave request? This is the final stage of approval.`
    );
    if (!confirmApprove) return;

    const requestId = request.leaveRequestId;
    if (!requestId) {
      this.showTemporaryError("Invalid request ID");
      return;
    }

    this.setState({ processingId: requestId });

    try {
      const finalApprovalData = {
        leaveRequestId: requestId,
        hrEmployeeCode: getEmployeeCodeFromSession(),
        employeeCode: request.employeeCode,
        status: "FINAL_APPROVE",
        rejectionReason: ""
      };

      const result = await this.props.FinalLeaveApprover(finalApprovalData);
      console.log("Final approve result:", result);

      if (result?.isSuccess) {
        this.showTemporarySuccess(`Leave request finally approved successfully!`);
        this.fetchAllLeaveRequests(); // Refresh all leave requests
      } else {
        this.showTemporaryError(result?.message || "Failed to process final approval");
      }
    } catch (error) {
      console.error("Final approve error:", error);
      this.showTemporaryError("Error processing final approval");
    } finally {
      this.setState({ processingId: null });
    }
  };

  handleFinalReject = async (request: LeaveRecord) => {
    const rejectionReason = window.prompt("Please enter reason for final rejection:", "");
    if (rejectionReason === null) return;
    if (!rejectionReason.trim()) {
      this.showTemporaryError("Rejection reason is required");
      return;
    }

    const requestId = request.leaveRequestId;
    if (!requestId) {
      this.showTemporaryError("Invalid request ID");
      return;
    }

    this.setState({ processingId: requestId });

    try {
      const finalRejectData = {
        leaveRequestId: requestId,
        hrEmployeeCode: getEmployeeCodeFromSession(),
        employeeCode: request.employeeCode,
        status: "FINAL_REJECT",
        rejectionReason: rejectionReason
      };

      const result = await this.props.FinalLeaveApprover(finalRejectData);
      console.log("Final reject result:", result);

      if (result?.isSuccess) {
        this.showTemporarySuccess(`Leave request finally rejected successfully!`);
        this.fetchAllLeaveRequests(); // Refresh all leave requests
      } else {
        this.showTemporaryError(result?.message || "Failed to process final rejection");
      }
    } catch (error) {
      console.error("Final reject error:", error);
      this.showTemporaryError("Error processing final rejection");
    } finally {
      this.setState({ processingId: null });
    }
  };

  handleViewDetails = (request: LeaveRecord) => {
    alert(`
      Leave Request Details:
      Request ID: ${request.leaveRequestId}
      Employee: ${request.employeeName}
      Employee Code: ${request.employeeCode}
      Leave Type: ${request.leaveType}
      From: ${new Date(request.fromDate).toLocaleDateString()}
      To: ${new Date(request.toDate).toLocaleDateString()}
      Days: ${request.days || 0}
      Reason: ${request.reason || 'N/A'}
      Applied On: ${new Date(request.appliedOn || request.createdOn || new Date()).toLocaleDateString()}
      Status: ${request.status}
    `);
  };

  getLeaveStatistics = () => {
    const { allLeaveRequests } = this.state;
    const pending = allLeaveRequests.filter(r => r.status?.toLowerCase() === 'pending').length;
    const approved = allLeaveRequests.filter(r => r.status?.toLowerCase() === 'approved').length;
    const rejected = allLeaveRequests.filter(r => r.status?.toLowerCase() === 'rejected').length;
    const finalApproved = allLeaveRequests.filter(r => r.status?.toLowerCase() === 'final approved').length;
    const finalRejected = allLeaveRequests.filter(r => r.status?.toLowerCase() === 'final rejected').length;
    const totalDays = allLeaveRequests.reduce((acc, curr) => acc + (curr.days || 0), 0);

    return { pending, approved, rejected, finalApproved, finalRejected, totalDays, total: allLeaveRequests.length };
  };

  testApiConnection = async () => {
    try {
      const result = await this.props.GetAllEmployees();
      console.log("API Test - GetAllEmployees response:", result);
      this.showTemporarySuccess("API connection successful!");
    } catch (error) {
      console.error("API Test - Error:", error);
      this.showTemporaryError("API connection failed!");
    }
  };

  render() {
    console.log("Rendering with employees:", this.state.employees);

    const {
      allLeaveRequests,
      filteredLeaveRequests,
      loading,
      processingId,
      filteredEmployees,
      employeeLoading,
      newEmployeeForm,
      showEditModal,
      editingEmployee,
      searchTerm,
      departmentFilter,
      statusFilter,
      leaveTypeFilter,
      leaveStatusFilter,
      fromDateFilter,
      toDateFilter,
      showPassword,
      showEditPassword,
      showSuccessMessage,
      showErrorMessage,
      editPassword,
      imageError,
      photoPreview,
      editPhotoPreview,
      isUploading,
      isEditUploading
    } = this.state;

    const leaveStats = this.getLeaveStatistics();
    const roleCode = sessionStorage.getItem('RoleCode');
    const isAdmin = roleCode === 'ADMIN';
    const isHRMGR = roleCode === 'HR_MGR';

    return (
      <>
        <style>{globalStyles}</style>

        <input
          type="file"
          ref={this.fileInputRef}
          onChange={this.handlePhotoUpload}
          accept="image/jpeg,image/png,image/gif,image/webp"
          style={{ display: 'none' }}
        />
        <input
          type="file"
          ref={this.editFileInputRef}
          onChange={this.handleEditPhotoUpload}
          accept="image/jpeg,image/png,image/gif,image/webp"
          style={{ display: 'none' }}
        />

        <div style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 1000 }}>
          <button
            onClick={this.testApiConnection}
            style={{
              background: '#00d2c8',
              color: '#04111a',
              border: 'none',
              borderRadius: '16px',
              padding: '6px 12px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '11px'
            }}
          >
            Test API
          </button>
        </div>

        <div className="em-page">
          <div style={{
            position: 'fixed', top: '5%', left: '8%', width: 420, height: 420,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(0,160,155,.2) 0%, transparent 68%)',
            animation: 'orbPulse1 11s ease-in-out infinite',
            pointerEvents: 'none', zIndex: 0,
          }} />
          <div style={{
            position: 'fixed', bottom: '8%', right: '6%', width: 500, height: 500,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(0,120,175,.15) 0%, transparent 68%)',
            animation: 'orbPulse2 15s ease-in-out infinite',
            pointerEvents: 'none', zIndex: 0,
          }} />

          <div className="em-grid-bg" />

          {PARTICLES.map(p => (
            <div key={p.id} className="em-particle" style={{
              width: p.size, height: p.size,
              left: `${p.left}%`, bottom: -p.size,
              ['--dur' as any]: `${p.dur}s`,
              ['--delay' as any]: `${p.delay}s`,
              ['--dx' as any]: `${p.dx}px`,
            }} />
          ))}

          <div className="em-breadcrumb">
            <span className="em-breadcrumb-current">Employee Management</span>
          </div>

          <div className="em-content">
            {showSuccessMessage && (
              <div className="em-success-message">{showSuccessMessage}</div>
            )}
            {showErrorMessage && (
              <div className="em-error-message">{showErrorMessage}</div>
            )}

            {(employeeLoading || loading) && (
              <div style={{ textAlign: 'center', padding: '8px', color: '#00d2c8', fontSize: '12px' }}>
                Loading...
              </div>
            )}

            <div className="em-section">
              <div className="em-shimmer-line" />
              <div className="em-section-header" style={{ cursor: 'default' }}>
                <span className="em-section-title">Employee Overview</span>
                <span className="em-toggle-btn">−</span>
              </div>
              <div className="em-section-body">
                <div className="em-stats-grid">
                  <div className="em-stat-card">
                    <div className="em-stat-value">{filteredEmployees.length}</div>
                    <div className="em-stat-label">Total Employees</div>
                  </div>
                  <div className="em-stat-card">
                    <div className="em-stat-value">
                      {filteredEmployees.filter(e => e.isActive === true).length}
                    </div>
                    <div className="em-stat-label">Active Employees</div>
                  </div>
                  <div className="em-stat-card">
                    <div className="em-stat-value">
                      {filteredEmployees.filter(e => e.isActive === false).length}
                    </div>
                    <div className="em-stat-label">Inactive Employees</div>
                  </div>
                  <div className="em-stat-card">
                    <div className="em-stat-value">{leaveStats.total}</div>
                    <div className="em-stat-label">Total Leave Requests</div>
                  </div>
                </div>
              </div>
            </div>

            <CollapsibleSection title="➕ Add New Employee" defaultOpen={true}>
              <div className="em-photo-upload-container">
                {photoPreview || newEmployeeForm.photoPath ? (
                  <div style={{ position: 'relative' }}>
                    <img
                      src={photoPreview || newEmployeeForm.photoPath || ''}
                      alt="Preview"
                      className="em-photo-preview"
                      onError={(e) => {
                        console.log("Image failed to load:", (e.target as HTMLImageElement).src);
                        (e.target as HTMLImageElement).src = DEFAULT_AVATAR;
                      }}
                    />
                  </div>
                ) : (
                  <div className="em-photo-placeholder">
                    📷
                  </div>
                )}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <span
                      className="em-action-btn"
                      onClick={this.triggerFileInput}
                      style={{
                        opacity: 0.5,
                        cursor: 'not-allowed',
                        pointerEvents: 'none'
                      }}
                    >
                      {photoPreview || newEmployeeForm.photoPath ? '📷 Change' : '📷 Upload'}
                    </span>
                    {(photoPreview || newEmployeeForm.photoPath) && (
                      <span
                        className="em-action-btn em-action-btn-danger"
                        style={{
                          opacity: 0.5,
                          cursor: 'not-allowed',
                          pointerEvents: 'none'
                        }}
                      >
                        🗑️ Remove
                      </span>
                    )}
                  </div>
                  <div style={{ fontSize: '10px', color: '#7ab0b8' }}>
                    Max 5MB (JPG, PNG, GIF, WEBP)
                  </div>
                </div>
              </div>

              <Row>
                <Field
                  label="Employee Code *"
                  value={newEmployeeForm.employeeCode || ''}
                  width="12%"
                  placeholder="EMP001"
                  onChange={(e) => this.handleNewEmployeeInputChange('employeeCode', e.target.value)}
                />
                <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '8px' }}>
                  <div className="em-code-hint">Format: EMP001</div>
                </div>
                <Field
                  label="First Name *"
                  value={newEmployeeForm.firstName || ''}
                  width="12%"
                  onChange={(e) => this.handleNewEmployeeInputChange('firstName', e.target.value)}
                />
                <Field
                  label="Last Name"
                  value={newEmployeeForm.lastName || ''}
                  width="12%"
                  onChange={(e) => this.handleNewEmployeeInputChange('lastName', e.target.value)}
                />
                <Field
                  label="Email *"
                  value={newEmployeeForm.email || ''}
                  width="15%"
                  type="email"
                  onChange={(e) => this.handleNewEmployeeInputChange('email', e.target.value)}
                />
                <Field
                  label="Phone *"
                  value={newEmployeeForm.mobileNumber || ''}
                  width="12%"
                  onChange={(e) => this.handleNewEmployeeInputChange('mobileNumber', e.target.value)}
                />
                <Field
                  label="Password *"
                  value={newEmployeeForm.password || ''}
                  width="12%"
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => this.handleNewEmployeeInputChange('password', e.target.value)}
                  showPasswordStrength={true}
                />
                <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '8px' }}>
                  <span
                    className="em-action-btn"
                    style={{ padding: '4px 8px', height: '32px', fontSize: '11px' }}
                    onClick={this.togglePasswordVisibility}
                  >
                    {showPassword ? '👁️ Hide' : '👁️ Show'}
                  </span>
                </div>
              </Row>
              <Row>
                <Field
                  label="Department"
                  value={newEmployeeForm.department || 'Engineering'}
                  width="15%"
                  isSelect
                  options={departments}
                  onChange={(e) => this.handleNewEmployeeInputChange('department', e.target.value)}
                />
                <Field
                  label="Designation"
                  value={newEmployeeForm.designation || 'Software Developer'}
                  width="18%"
                  isSelect
                  options={designations}
                  onChange={(e) => this.handleNewEmployeeInputChange('designation', e.target.value)}
                />
                <Field
                  label="Employment Status"
                  value={newEmployeeForm.employmentStatus || 'Full Time'}
                  width="15%"
                  isSelect
                  options={employmentStatusOptions}
                  onChange={(e) => this.handleNewEmployeeInputChange('employmentStatus', e.target.value)}
                />
                <Field
                  label="Date of Birth"
                  value={newEmployeeForm.dateOfBirth || ''}
                  width="12%"
                  type="date"
                  onChange={(e) => this.handleNewEmployeeInputChange('dateOfBirth', e.target.value)}
                />
                <Field
                  label="Join Date"
                  value={newEmployeeForm.joinDate || ''}
                  width="12%"
                  type="date"
                  onChange={(e) => this.handleNewEmployeeInputChange('joinDate', e.target.value)}
                />
                <Field
                  label="Status"
                  value={newEmployeeForm.isActive ? 'Active' : 'Inactive'}
                  width="12%"
                  isSelect
                  options={statusOptions}
                  onChange={(e) => this.handleNewEmployeeInputChange('isActive', e.target.value === 'Active')}
                />
              </Row>
              <Row>
                <Field
                  label="Address"
                  value={newEmployeeForm.employeeAddress || ''}
                  width="30%"
                  onChange={(e) => this.handleNewEmployeeInputChange('employeeAddress', e.target.value)}
                />
                <Field
                  label="Address Line 2"
                  value={newEmployeeForm.addressLine2 || ''}
                  width="20%"
                  onChange={(e) => this.handleNewEmployeeInputChange('addressLine2', e.target.value)}
                />
                <Field
                  label="City"
                  value={newEmployeeForm.city || ''}
                  width="15%"
                  onChange={(e) => this.handleNewEmployeeInputChange('city', e.target.value)}
                />
                <Field
                  label="State"
                  value={newEmployeeForm.state || 'West Bengal'}
                  width="15%"
                  onChange={(e) => this.handleNewEmployeeInputChange('state', e.target.value)}
                />
                <Field
                  label="Pincode"
                  value={newEmployeeForm.pincode || ''}
                  width="10%"
                  onChange={(e) => this.handleNewEmployeeInputChange('pincode', e.target.value)}
                />
              </Row>
              <Row>
                <Field
                  label="Emergency Contact Name"
                  value={newEmployeeForm.emergencyContactName || ''}
                  width="20%"
                  onChange={(e) => this.handleNewEmployeeInputChange('emergencyContactName', e.target.value)}
                />
                <Field
                  label="Emergency Contact Number"
                  value={newEmployeeForm.emergencyContactNumber || ''}
                  width="20%"
                  onChange={(e) => this.handleNewEmployeeInputChange('emergencyContactNumber', e.target.value)}
                />
                <Field
                  label="Relationship"
                  value={newEmployeeForm.relationship || ''}
                  width="15%"
                  onChange={(e) => this.handleNewEmployeeInputChange('relationship', e.target.value)}
                />
                <Field
                  label="Role ID"
                  value={newEmployeeForm.roleId?.toString() || '2'}
                  width="10%"
                  type="number"
                  onChange={(e) => this.handleNewEmployeeInputChange('roleId', parseInt(e.target.value, 10))}
                />
                <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', marginLeft: 'auto' }}>
                  <span
                    className="em-action-btn"
                    style={{ background: 'rgba(0,210,200,.25)' }}
                    onClick={this.handleCreateEmployee}
                  >
                    {employeeLoading ? '⏳ Saving...' : '💾 Save'}
                  </span>
                  <span
                    className="em-action-btn"
                    onClick={this.resetNewEmployeeForm}
                  >
                    ↻ Reset
                  </span>
                </div>
              </Row>
              <Row>
                <div style={{ fontSize: '10px', color: '#7ab0b8', marginTop: '4px' }}>
                  * Required fields - Employee Code format: EMP001
                </div>
              </Row>
            </CollapsibleSection>

            <CollapsibleSection title="👥 All Employees" defaultOpen={true}>
              <div className="em-filter-bar">
                <Field
                  label="Department"
                  value={departmentFilter}
                  width="15%"
                  isSelect
                  options={['All', ...departments]}
                  onChange={(e) => this.setState({ departmentFilter: e.target.value })}
                />
                <Field
                  label="Status"
                  value={statusFilter}
                  width="12%"
                  isSelect
                  options={['All', ...statusOptions]}
                  onChange={(e) => this.setState({ statusFilter: e.target.value })}
                />
                <Field
                  label="Search"
                  value={searchTerm}
                  width="25%"
                  placeholder="Search by name, code, email, phone..."
                  onChange={(e) => this.setState({ searchTerm: e.target.value })}
                />
                <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
                  <span className="em-action-btn" onClick={this.fetchAllData}>↻ Refresh</span>
                  <span className="em-action-btn" onClick={this.clearFilters}>🗑️ Clear</span>
                  <span className="em-action-btn">📥 Export</span>
                </div>
              </div>

              {(departmentFilter !== "All" || statusFilter !== "All" || searchTerm) && (
                <div style={{
                  fontSize: '10px',
                  color: '#00d2c8',
                  marginBottom: '8px',
                  padding: '4px 8px',
                  background: 'rgba(0,210,200,.1)',
                  borderRadius: '4px'
                }}>
                  Showing {filteredEmployees.length} of {this.state.employees.length} employees
                </div>
              )}

              <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                <table className="em-table" style={{ minWidth: '2400px' }}>
                  <thead>
                    <tr>
                      <th>Actions</th>
                      <th>Emp Code</th>
                      <th>Employee Name</th>
                      <th style={{ textAlign: "center" }}>Email</th>
                      <th>Phone</th>
                      <th>Date of Birth</th>
                      <th>Age</th>
                      <th>Gender</th>
                      <th>City</th>
                      <th>State</th>
                      <th>Pincode</th>
                      <th style={{ textAlign: "center" }}>Address</th>
                      <th>Dept</th>
                      <th>Designation</th>
                      <th>Join Date</th>
                      <th>Emp Status</th>
                      <th>Exp Years</th>
                      <th>Emergency Contact</th>
                      <th>Emergency Phone</th>
                      <th>Relationship</th>
                      <th>Role</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredEmployees.length > 0 ? (
                      filteredEmployees.map((employee) => {
                        return (
                          <tr key={employee.employeeId}>
                            <td>
                              <div style={{ display: 'flex', gap: '4px' }}>
                                <span
                                  className="em-action-btn"
                                  style={{ padding: '4px 8px' }}
                                  title="View Details"
                                  onClick={() => {
                                    const details = Object.entries(employee)
                                      .map(([key, value]) => `${key}: ${value !== null ? value : 'N/A'}`)
                                      .join('\n');
                                    alert(details);
                                  }}
                                >
                                  👁️
                                </span>
                                <span
                                  className="em-action-btn"
                                  style={{ padding: '4px 8px' }}
                                  title="Edit"
                                  onClick={() => this.handleEditClick(employee)}
                                >
                                  ✏️
                                </span>
                                <span
                                  className="em-action-btn em-action-btn-danger"
                                  style={{ padding: '4px 8px', cursor: processingId === `delete-${employee.employeeId}` ? 'not-allowed' : 'pointer' }}
                                  title="Delete"
                                  onClick={() => !processingId?.startsWith('delete') && this.handleDeleteEmployee(employee.employeeId, employee.employeeCode, employee.employeeName || employee.displayName || `${employee.firstName} ${employee.lastName}`)}
                                >
                                  {processingId === `delete-${employee.employeeId}` ? '⏳' : '🗑️'}
                                </span>
                              </div>
                            </td>
                            <td style={{ color: '#00d2c8', fontWeight: '600', fontSize: '11px' }}>{employee.employeeCode}</td>
                            <td>{employee.displayName || employee.employeeName || `${employee.firstName} ${employee.lastName}` || 'N/A'}</td>
                            <td>{employee.email || 'N/A'}</td>
                            <td>{employee.mobileNumber || 'N/A'}</td>
                            <td>{employee.dateOfBirth || 'N/A'}</td>
                            <td>{employee.employeeAge || 'N/A'}</td>
                            <td>{employee.gender || 'N/A'}</td>
                            <td>{employee.city || 'N/A'}</td>
                            <td>{employee.state || 'N/A'}</td>
                            <td>{employee.pincode || 'N/A'}</td>
                            <td style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{employee.fullAddress || employee.employeeAddress || 'N/A'}</td>
                            <td>{employee.department || 'N/A'}</td>
                            <td>{employee.designation || 'N/A'}</td>
                            <td>{employee.joinDate || 'N/A'}</td>
                            <td>{employee.employmentStatus || 'N/A'}</td>
                            <td>{employee.experienceYears || 0}</td>
                            <td>{employee.emergencyContactName || 'N/A'}</td>
                            <td>{employee.emergencyContactNumber || 'N/A'}</td>
                            <td>{employee.relationship || 'N/A'}</td>
                            <td>{employee.roleName || 'N/A'}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={21} className="em-empty-state">
                          No employees found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <Row>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '16px' }}>
                  <div style={{ fontSize: '10px', color: '#7ab0b8' }}>
                    Showing {filteredEmployees.length} of {this.state.employees.length} employees
                  </div>
                  <div style={{ display: 'flex', gap: '4px' }}>
                    <span className="em-action-btn" style={{ padding: '4px 8px' }}>◀</span>
                    <span className="em-action-btn" style={{ padding: '4px 8px', background: 'rgba(0,210,200,.25)' }}>1</span>
                    <span className="em-action-btn" style={{ padding: '4px 8px' }}>▶</span>
                  </div>
                </div>
              </Row>
            </CollapsibleSection>

            <CollapsibleSection title="📋 Leave Requests (All Status)" defaultOpen={true}>
              <Row>
                <div className="em-stats-grid">
                  <div className="em-stat-card">
                    <div className="em-stat-value">{leaveStats.total}</div>
                    <div className="em-stat-label">Total Requests</div>
                  </div>
                  <div className="em-stat-card">
                    <div className="em-stat-value">{leaveStats.pending}</div>
                    <div className="em-stat-label">Pending</div>
                  </div>
                  <div className="em-stat-card">
                    <div className="em-stat-value">{leaveStats.approved}</div>
                    <div className="em-stat-label">Approved</div>
                  </div>
                  <div className="em-stat-card">
                    <div className="em-stat-value">{leaveStats.rejected}</div>
                    <div className="em-stat-label">Rejected</div>
                  </div>
                  <div className="em-stat-card">
                    <div className="em-stat-value">{leaveStats.finalApproved}</div>
                    <div className="em-stat-label">Final Approved</div>
                  </div>
                  <div className="em-stat-card">
                    <div className="em-stat-value">{leaveStats.finalRejected}</div>
                    <div className="em-stat-label">Final Rejected</div>
                  </div>
                  <div className="em-stat-card">
                    <div className="em-stat-value">{leaveStats.totalDays}</div>
                    <div className="em-stat-label">Total Days</div>
                  </div>
                </div>
              </Row>

              <div className="em-filter-bar">
                <Field
                  label="Leave Type"
                  value={leaveTypeFilter}
                  width="15%"
                  isSelect
                  options={leaveTypes}
                  onChange={(e) => this.setState({ leaveTypeFilter: e.target.value })}
                />
                <Field
                  label="Leave Status"
                  value={leaveStatusFilter}
                  width="15%"
                  isSelect
                  options={leaveStatusOptions}
                  onChange={(e) => this.setState({ leaveStatusFilter: e.target.value })}
                />
                <Field
                  label="From Date"
                  value={fromDateFilter}
                  width="12%"
                  type="date"
                  onChange={(e) => this.setState({ fromDateFilter: e.target.value })}
                />
                <Field
                  label="To Date"
                  value={toDateFilter}
                  width="12%"
                  type="date"
                  onChange={(e) => this.setState({ toDateFilter: e.target.value })}
                />
                <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
                  <span
                    className="em-action-btn"
                    onClick={() => this.fetchAllLeaveRequests()}
                  >
                    🔍 Filter
                  </span>
                  <span
                    className="em-action-btn"
                    onClick={this.clearLeaveFilters}
                  >
                    ↻ Reset
                  </span>
                </div>
              </div>

              {loading ? (
                <div className="em-empty-state">
                  Loading leave requests...
                </div>
              ) : filteredLeaveRequests.length > 0 ? (
                <table className="em-table">
                  <thead>
                    <tr>
                      <th>Request ID</th>
                      <th>Employee</th>
                      <th>Emp Code</th>
                      <th>Leave Type</th>
                      <th>From Date</th>
                      <th>To Date</th>
                      <th>Days</th>
                      <th>Applied On</th>
                      <th>Status</th>
                      <th>Reason</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredLeaveRequests.map((request) => {
                      const requestId = request.leaveRequestId || '';
                      const isProcessing = processingId === requestId;
                      const isPending = request.status?.toLowerCase() === 'pending';
                      const isApproved = request.status === 'Approved';

                      return (
                        <tr key={requestId} style={{ opacity: isProcessing ? 0.6 : 1 }}>
                          <td style={{ color: '#00d2c8', fontWeight: '600', fontSize: '11px' }}>
                            {requestId}
                          </td>
                          <td>{request.employeeName}</td>
                          <td>{request.employeeCode}</td>
                          <td>{request.leaveType}</td>
                          <td>{new Date(request.fromDate).toLocaleDateString('en-GB')}</td>
                          <td>{new Date(request.toDate).toLocaleDateString('en-GB')}</td>
                          <td style={{ fontWeight: '600' }}>{request.days || 0}</td>
                          <td>{new Date(request.appliedOn || request.createdOn || new Date()).toLocaleDateString('en-GB')}</td>
                          <td>
                            <Badge status={request.status || ''} />
                          </td>
                          <td style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {request.reason || ''}
                          </td>
                          <td>
                            <div style={{ display: 'flex', gap: '4px' }}>
                              {isPending && isHRMGR && (
                                <span
                                  className="em-action-btn em-action-btn-success"
                                  style={{ padding: '4px 8px', cursor: isProcessing ? 'not-allowed' : 'pointer' }}
                                  title="Approve (Level 1)"
                                  onClick={() => !isProcessing && this.handleApprove(request)}
                                >
                                  {isProcessing ? '⏳' : '✓'}
                                </span>
                              )}
                              {isPending && isHRMGR && (
                                <span
                                  className="em-action-btn em-action-btn-danger"
                                  style={{ padding: '4px 8px', cursor: isProcessing ? 'not-allowed' : 'pointer' }}
                                  title="Reject (Level 1)"
                                  onClick={() => !isProcessing && this.handleReject(request)}
                                >
                                  ✗
                                </span>
                              )}
                              {isApproved && isAdmin && (
                                <span
                                  className="em-action-btn"
                                  style={{ padding: '4px 8px', background: 'rgba(0,160,155,.4)', cursor: isProcessing ? 'not-allowed' : 'pointer' }}
                                  title="Final Approve (Level 2)"
                                  onClick={() => !isProcessing && this.handleFinalApprove(request)}
                                >
                                  ✓✓
                                </span>
                              )}
                              { isApproved && isAdmin && (
                                <span
                                  className="em-action-btn em-action-btn-danger"
                                  style={{ padding: '4px 8px', background: 'rgba(255,80,80,.4)', cursor: isProcessing ? 'not-allowed' : 'pointer' }}
                                  title="Final Reject (Level 2)"
                                  onClick={() => !isProcessing && this.handleFinalReject(request)}
                                >
                                  ✗✗
                                </span>
                              )}
                              <span
                                className="em-action-btn"
                                style={{ padding: '4px 8px', cursor: 'pointer' }}
                                title="View Details"
                                onClick={() => this.handleViewDetails(request)}
                              >
                                👁️
                              </span>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <div className="em-empty-state">
                  No leave requests found.
                </div>
              )}

              <Row>
                <div style={{ display: 'flex', gap: '8px', marginTop: '16px', justifyContent: 'flex-end', width: '100%' }}>
                  <span className="em-action-btn">📋 View History</span>
                  <span className="em-action-btn">📊 Generate Report</span>
                </div>
              </Row>
            </CollapsibleSection>

            {showEditModal && editingEmployee && (
              <div className="em-modal">
                <div className="em-modal-content">
                  <div className="em-modal-title">Edit Employee: {editingEmployee.displayName || editingEmployee.employeeName || `${editingEmployee.firstName} ${editingEmployee.lastName}`}</div>

                  <div className="em-photo-upload-container">
                    {editPhotoPreview || this.getEmployeePhotoUrl(editingEmployee) ? (
                      <div style={{ position: 'relative' }}>
                        <img
                          src={editPhotoPreview || this.getEmployeePhotoUrl(editingEmployee)}
                          alt="Preview"
                          className="em-photo-preview"
                          onError={(e) => {
                            console.log("Image failed to load in edit modal:", (e.target as HTMLImageElement).src);
                            (e.target as HTMLImageElement).src = DEFAULT_AVATAR;
                          }}
                        />
                      </div>
                    ) : (
                      <div className="em-photo-placeholder">
                        📷
                      </div>
                    )}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <span
                          className="em-action-btn"
                          onClick={this.triggerFileInput}
                          style={{
                            opacity: 0.5,
                            cursor: 'not-allowed',
                            pointerEvents: 'none'
                          }}
                        >
                          {photoPreview || newEmployeeForm.photoPath ? '📷 Change' : '📷 Upload'}
                        </span>
                        {(photoPreview || newEmployeeForm.photoPath) && (
                          <span
                            className="em-action-btn em-action-btn-danger"
                            style={{
                              opacity: 0.5,
                              cursor: 'not-allowed',
                              pointerEvents: 'none'
                            }}
                          >
                            🗑️ Remove
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: '10px', color: '#7ab0b8' }}>
                        Max 5MB (JPG, PNG, GIF, WEBP)
                      </div>
                    </div>
                  </div>

                  <Row>
                    <Field
                      label="Employee Code"
                      value={editingEmployee.employeeCode || ''}
                      width="20%"
                      disabled
                    />
                    <Field
                      label="First Name"
                      value={editingEmployee.firstName || ''}
                      width="25%"
                      onChange={(e) => this.handleEditInputChange('firstName', e.target.value)}
                    />
                    <Field
                      label="Last Name"
                      value={editingEmployee.lastName || ''}
                      width="25%"
                      onChange={(e) => this.handleEditInputChange('lastName', e.target.value)}
                    />
                    <Field
                      label="Email"
                      value={editingEmployee.email || ''}
                      width="25%"
                      type="email"
                      onChange={(e) => this.handleEditInputChange('email', e.target.value)}
                    />
                  </Row>

                  <Row>
                    <Field
                      label="Phone"
                      value={editingEmployee.mobileNumber || ''}
                      width="25%"
                      onChange={(e) => this.handleEditInputChange('mobileNumber', e.target.value)}
                    />
                    <Field
                      label="Department"
                      value={editingEmployee.department || ''}
                      width="25%"
                      isSelect
                      options={departments}
                      onChange={(e) => this.handleEditInputChange('department', e.target.value)}
                    />
                    <Field
                      label="Designation"
                      value={editingEmployee.designation || ''}
                      width="25%"
                      isSelect
                      options={designations}
                      onChange={(e) => this.handleEditInputChange('designation', e.target.value)}
                    />
                    <Field
                      label="Employment Status"
                      value={editingEmployee.employmentStatus || 'Full Time'}
                      width="25%"
                      isSelect
                      options={employmentStatusOptions}
                      onChange={(e) => this.handleEditInputChange('employmentStatus', e.target.value)}
                    />
                  </Row>

                  <Row>
                    <Field
                      label="Date of Birth"
                      value={editingEmployee.dateOfBirth || ''}
                      width="20%"
                      type="date"
                      onChange={(e) => this.handleEditInputChange('dateOfBirth', e.target.value)}
                    />
                    <Field
                      label="Join Date"
                      value={editingEmployee.joinDate || ''}
                      width="20%"
                      type="date"
                      onChange={(e) => this.handleEditInputChange('joinDate', e.target.value)}
                    />
                    <Field
                      label="Status"
                      value={editingEmployee.isActive ? 'Active' : 'Inactive'}
                      width="20%"
                      isSelect
                      options={statusOptions}
                      onChange={(e) => this.handleEditInputChange('isActive', e.target.value === 'Active')}
                    />
                  </Row>

                  <Row>
                    <Field
                      label="Address"
                      value={editingEmployee.employeeAddress || ''}
                      width="40%"
                      onChange={(e) => this.handleEditInputChange('employeeAddress', e.target.value)}
                    />
                    <Field
                      label="Address Line 2"
                      value={editingEmployee.addressLine2 || ''}
                      width="30%"
                      onChange={(e) => this.handleEditInputChange('addressLine2', e.target.value)}
                    />
                  </Row>

                  <Row>
                    <Field
                      label="City"
                      value={editingEmployee.city || ''}
                      width="20%"
                      onChange={(e) => this.handleEditInputChange('city', e.target.value)}
                    />
                    <Field
                      label="State"
                      value={editingEmployee.state || ''}
                      width="20%"
                      onChange={(e) => this.handleEditInputChange('state', e.target.value)}
                    />
                    <Field
                      label="Pincode"
                      value={editingEmployee.pincode || ''}
                      width="15%"
                      onChange={(e) => this.handleEditInputChange('pincode', e.target.value)}
                    />
                  </Row>

                  <Row>
                    <Field
                      label="Emergency Contact"
                      value={editingEmployee.emergencyContactName || ''}
                      width="30%"
                      onChange={(e) => this.handleEditInputChange('emergencyContactName', e.target.value)}
                    />
                    <Field
                      label="Emergency Phone"
                      value={editingEmployee.emergencyContactNumber || ''}
                      width="25%"
                      onChange={(e) => this.handleEditInputChange('emergencyContactNumber', e.target.value)}
                    />
                    <Field
                      label="Relationship"
                      value={editingEmployee.relationship || ''}
                      width="20%"
                      onChange={(e) => this.handleEditInputChange('relationship', e.target.value)}
                    />
                    <Field
                      label="Role ID"
                      value={editingEmployee.roleId?.toString() || ''}
                      width="15%"
                      type="number"
                      onChange={(e) => this.handleEditInputChange('roleId', parseInt(e.target.value, 10))}
                    />
                  </Row>

                  <Row>
                    <Field
                      label="New Password (leave blank to keep)"
                      value={editPassword}
                      width="50%"
                      type={showEditPassword ? "text" : "password"}
                      placeholder="Enter new password"
                      onChange={(e) => this.setState({ editPassword: e.target.value })}
                      showPasswordStrength={editPassword.length > 0}
                    />
                    <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '8px' }}>
                      <span
                        className="em-action-btn"
                        style={{ padding: '4px 8px', height: '32px', fontSize: '11px' }}
                        onClick={this.toggleEditPasswordVisibility}
                      >
                        {showEditPassword ? '👁️ Hide' : '👁️ Show'}
                      </span>
                    </div>
                  </Row>

                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <span
                      className="em-action-btn em-action-btn-success"
                      onClick={this.handleUpdateEmployee}
                    >
                      {employeeLoading ? '⏳ Updating...' : '💾 Update'}
                    </span>
                    <span
                      className="em-action-btn"
                      onClick={() => this.setState({ showEditModal: false, editingEmployee: null, editPassword: "", selectedEditPhotoFile: null, editPhotoPreview: null })}
                    >
                      Cancel
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (state: any) => {
  console.log("Redux state in mapStateToProps:", state);
  return {
    leaveRecords: state.leave?.records || [],
    employeeRecords: state.employee?.records || [],
    loading: state.employee?.loading || false,
    manageStatus: state.employee?.manageStatus,
    error: state.employee?.error
  };
};

const mapDispatchToProps = {
  GetLeaveDetails,
  GetAllEmployees,
  ManageLeaveApproval,
  FinalLeaveApprover,
  ManageEmployee
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeManagementPage);